import React from 'react';
import CarouselSection from './components/carousel-section';
import useSpecificSubjectContext from './context';
import { useDataFromSlug } from '~/helpers/page-data-utils';
import useOptimizedImage from '~/helpers/use-optimized-image';
import useEnglishSubject from './use-english-subject';
import { useIntl } from 'react-intl';
import './blog-posts.scss';
import { assertDefined } from '~/helpers/data';
function Card({ article_image: image, title: linkText, slug }) {
    const link = `/blog/${slug}`;
    const optimizedImage = useOptimizedImage(image, 400);
    return (React.createElement("div", { className: "card" },
        React.createElement("img", { src: optimizedImage, role: "presentation" }),
        React.createElement("a", { href: link }, linkText)));
}
function BlogPosts() {
    const { content: { heading, blogDescription, linkText, linkHref } } = assertDefined(useSpecificSubjectContext().blogHeader);
    const cms = useEnglishSubject();
    const blurbs = useDataFromSlug(`search/?subjects=${cms}`) || [];
    const intl = useIntl();
    return (blurbs.length ?
        React.createElement(CarouselSection, { heading: heading, description: blogDescription, linkUrl: linkHref, linkText: linkText, thing: 'blog entries', minWidth: 260 }, blurbs.map((blurb) => React.createElement(Card, Object.assign({}, blurb, { key: blurb.id })))) :
        React.createElement("h2", null, intl.formatMessage({ id: 'subject.noBlog' })));
}
export default function MaybeBlogPosts() {
    const ctx = useSpecificSubjectContext();
    if (!(ctx === null || ctx === void 0 ? void 0 : ctx.blogHeader)) {
        return null;
    }
    return (React.createElement(BlogPosts, null));
}
